import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import WhatIs from "@/components/WhatIs";
import Services from "@/components/Services";
import WhyChoose from "@/components/WhyChoose";
import Testimonials from "@/components/Testimonials";
import Booking from "@/components/Booking";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  const [presetServiceId, setPresetServiceId] = useState(null);

  const handleBook = (serviceId) => {
    setPresetServiceId(serviceId);
    setTimeout(() => {
      document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  return (
    <div data-testid="home-page" className="bg-background text-foreground">
      <Navbar />
      <Hero />
      <About />
      <WhatIs />
      <Services onBook={handleBook} />
      <WhyChoose />
      <Testimonials />
      <Booking presetServiceId={presetServiceId} setPresetServiceId={setPresetServiceId} />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
